import { container } from "tsyringe";
import { CariSTTApiRepository } from '../../repositories/api/CariSTTApiRepository';
import ApiService from '../../services/ApiService';
import { CariSTTMapper } from '@/data/persistences/mappers/CariSTTMapper';
import { CariSTTEndpoint } from '../../endpoints/CariSTTEndpoint';
import { ListCariSTTPresenter } from '@/app/ui/presenters/ListCariSTTPresenter';

export class ListCariSTTComponent {
  public static init() {
    container.register<CariSTTApiRepository>(CariSTTApiRepository, {
      useFactory: d => {
        return new CariSTTApiRepository(
          d.resolve(ApiService),
          d.resolve(CariSTTMapper),
          d.resolve(CariSTTEndpoint)
        )
      }
    });
    container.register<CariSTTMapper>(CariSTTMapper, {
      useClass: CariSTTMapper
    });
    container.register<ListCariSTTPresenter>(ListCariSTTPresenter, {
      useFactory: d => {
        return new ListCariSTTPresenter(d.resolve(CariSTTApiRepository))
      }
    })
  }
}
